import { collection, getDocs, limit, query } from "firebase/firestore";
import { useState } from "react";
import { useEffect } from "react";
import Spinner from "./Spinner";
import { db } from "../firebase";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  EffectFade,
  Autoplay,
  Navigation,
  Pagination,
} from "swiper";
import "swiper/css/bundle";

interface IData {
  id: string;
  data: any;
}
export default function Slider() {
  const [headers, setHeaders] = useState<IData[]>([]);
  const [loading, setLoading] = useState(true);
  SwiperCore.use([Autoplay, Navigation, Pagination]);

  useEffect(() => {
    async function fetchHeaders() {
      const headerRef = collection(db, "headers");
      const q = query(headerRef, limit(10));
      const querySnap = await getDocs(q);
      let headersDoc: IData[] = [];
      querySnap.forEach((doc) => {
        return headersDoc.push({
          id: doc.id,
          data: doc.data(),
        });
      });
      setHeaders(headersDoc);
      setLoading(false);
    }
    fetchHeaders();
  }, []);
  if (loading) {
    return <Spinner />;
  }
  if (headers.length === 0) {
    return <></>;
  }

  return (
    headers && (
      <>
        <Swiper
          slidesPerView={1}
          navigation
          pagination={{ type: "progressbar" }}
          effect="fade"
          modules={[EffectFade]}
          autoplay={{ delay: 7500 }}
        >
          {headers.map(({ data, id }) => (
            <SwiperSlide key={id}>
              <div
                style={{
                  background: `url(${data.imageURL}) center, no-repeat`,
                  backgroundSize: "cover",
                }}
                className="swiper-slide-background"
                role="img"
                title="Explore opportunities for semi-retired professionals, remote work, and part-time jobs"
                aria-label={
                  "Find flexible job opportunities for experienced professionals."
                }
              ></div>
              {/* <p className="swiper-slide-text">{"Find flexible job opportunities for experienced professionals."}</p> */}
            </SwiperSlide>
          ))}
        </Swiper>
      </>
    )
  );
}
